// extracted by mini-css-extract-plugin
module.exports = {"pill":"Pill-module-pill","withGradient":"Pill-module-with-gradient","title":"Pill-module-title","icon":"Pill-module-icon"};